// extracted by mini-css-extract-plugin
export default {"description":"SectionInfo_description__XU8gK"};